import { render } from "./Restore.vue?vue&type=template&id=37d61d83&scoped=true"
import script from "./Restore.vue?vue&type=script&lang=js"
export * from "./Restore.vue?vue&type=script&lang=js"

import "./Restore.vue?vue&type=style&index=0&id=37d61d83&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d61d83"]])

export default __exports__